const enviroments = {
    dev: 'dev',
    test: 'test',
    stag: 'stag',
    prod: 'prod'
};

const ENABLE_NATURA_PRODUCTS = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_MOVEMENTS = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_COLLECTIONS = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_USERS = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_CLIENTS_DETAIL = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_CANCELLATIONS = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_USERS_ACTIONS = [enviroments.dev, enviroments.test].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_DEVICE = [enviroments.dev, enviroments.test, enviroments.stag].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_SUMMARY = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_CTECH_USERS = [enviroments.dev, enviroments.test, enviroments.stag].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_CONSULTANTS = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_PAYMENT_LINKS = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_PAYMENT_MOVEMENTS = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_ACCOUNTS = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
const ENABLE_NATURA_FRAUD_PREVENTION = [enviroments.dev, enviroments.test, enviroments.stag, enviroments.prod].some(env => process.env.NODE_ENV.includes(env));
export default {
    enableProduct: ENABLE_NATURA_PRODUCTS,
    enableMovements: ENABLE_NATURA_MOVEMENTS,
    enableCollections: ENABLE_NATURA_COLLECTIONS,
    enableUsers: ENABLE_NATURA_USERS,
    enableClientsDetail: ENABLE_NATURA_CLIENTS_DETAIL,
    enableCancellations: ENABLE_NATURA_CANCELLATIONS,
    enableUsersActions: ENABLE_NATURA_USERS_ACTIONS,
    enableSummary: ENABLE_NATURA_SUMMARY,
    enableCtechUsers: ENABLE_NATURA_CTECH_USERS,
    enableDevice: ENABLE_NATURA_DEVICE,
    enableConsultants: ENABLE_NATURA_CONSULTANTS,
    enablePaymentLinks: ENABLE_NATURA_PAYMENT_LINKS,
    enablePaymentMovements: ENABLE_NATURA_PAYMENT_MOVEMENTS,
    enableFraudPrevention: ENABLE_NATURA_FRAUD_PREVENTION,
    enableAccounts: ENABLE_NATURA_ACCOUNTS,
};
